import includes from 'lodash/includes';
import moment from '@/utils/moment-wrapper';

export function isoDatesToTimestamps (rules) {
    if (!rules || !rules.map) {
        return rules;
    }

    const isoDate = /\d{4}-\d{2}-\d{2}/;
    const isoDateToTimestamp = (rule) => {
        const timestamps = {};
        if (includes(['time', 'date', 'counter'], rule.schema) && isoDate.test(rule.value)) {
            timestamps.value = moment(rule.value, { ignoreTimeZone: true }).valueOf();
        }

        if (isoDate.test(rule.first)) {
            timestamps.first = moment(rule.first, { ignoreTimeZone: true }).valueOf();
        }

        if (isoDate.test(rule.last)) {
            timestamps.last = moment(rule.last, { ignoreTimeZone: true }).valueOf();
        }

        return Object.assign({}, rule, timestamps);
    };

    return rules.map((rule) => {
        if (rule.or) {
            return {
                or: rule.or.map(isoDateToTimestamp),
            };
        }

        return isoDateToTimestamp(rule);
    });
}
